/**
 * The few things the first screen asks before the onboarding's own chunk is needed: whether the
 * rules were seen on this device, and whether this is a wide screen with a mouse.
 */
const RULES_KEY = 'orb.rules';
/** Rules seen (or skipped) on this device. */
export const rulesSeen = () => { try { return localStorage.getItem(RULES_KEY) === '1'; } catch { return true; } };
export const markRulesSeen = () => { try { localStorage.setItem(RULES_KEY, '1'); } catch { /* private mode: shown again next time */ } };
/** Wide screen with a mouse: the one-page onboarding and the compact nick field. */
export const wideScreen = () => typeof matchMedia === 'function' && matchMedia('(min-width: 900px) and (hover: hover)').matches;
